import { render, staticRenderFns } from "./cdgyxy.vue?vue&type=template&id=19f5a1f3&scoped=true&"
import script from "./cdgyxy.vue?vue&type=script&lang=js&"
export * from "./cdgyxy.vue?vue&type=script&lang=js&"
import style0 from "./cdgyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdgyxy.vue?vue&type=style&index=1&id=19f5a1f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5a1f3",
  null
  
)

export default component.exports